import React from 'react'
import { Pagination } from '../Pagination'

export const Reviews = () => {
    return (
        <>
            {/* <!-- Reviews --> */}
            <div id="listing-reviews" className="listing-section">
                <h3 className="listing-desc-headline margin-top-75 margin-bottom-20">Reviews <span>(12)</span></h3>

                {/* <!-- Rating Overview --> */}
                <div className="rating-overview">
                    <div className="rating-overview-box">
                        <span className="rating-overview-box-total">4.2</span>
                        <span className="rating-overview-box-percent">out of 5.0</span>
                        <div className="star-rating" data-rating="5"></div>
                    </div>

                    <div className="rating-bars">
                        <div className="rating-bars-item">
                            <span className="rating-bars-name">Service <i className="tip" data-tip-content="Quality of customer service and attitude to work with you"></i></span>
                            <span className="rating-bars-inner">
                                <span className="rating-bars-rating" data-rating="4.2">
                                    <span className="rating-bars-rating-inner"></span>
                                </span>
                                <strong>4.2</strong>
                            </span>
                        </div>
                        <div className="rating-bars-item">
                            <span className="rating-bars-name">Value for Money <i className="tip" data-tip-content="Overall experience received for the amount spent"></i></span>
                            <span className="rating-bars-inner">
                                <span className="rating-bars-rating" data-rating="2.8">
                                    <span className="rating-bars-rating-inner"></span>
                                </span>
                                <strong>2.8</strong>
                            </span>
                        </div>
                        <div className="rating-bars-item">
                            <span className="rating-bars-name">Location <i className="tip" data-tip-content="Visibility, commute or nearby parking spots"></i></span>
                            <span className="rating-bars-inner">
                                <span className="rating-bars-rating" data-rating="3.7">
                                    <span className="rating-bars-rating-inner"></span>
                                </span>
                                <strong>3.7</strong>
                            </span>
                        </div>
                        <div className="rating-bars-item">
                            <span className="rating-bars-name">Cleanliness <i className="tip" data-tip-content="The physical condition of the business"></i></span>
                            <span className="rating-bars-inner">
                                <span className="rating-bars-rating" data-rating="4.0">
                                    <span className="rating-bars-rating-inner"></span>
                                </span>
                                <strong>4.5</strong>
                            </span>
                        </div>
                    </div>
                </div>
                {/* <!-- Rating Overview / End --> */}


                <div className="clearfix"></div>

                {/* <!-- Reviews --> */}
                <section className="comments listing-reviews">
                    <ul>
                        <li>
                            <div className="avatar"><img src="http://www.gravatar.com/avatar/00000000000000000000000000000000?d=mm&amp;s=70" alt="" /></div>
                            <div className="comment-content"><div className="arrow-comment"></div>
                                <div className="comment-by">Kathy Brown <i className="tip" data-tip-content="Person who left this review actually was a customer"></i> <span className="date">June 2019</span>
                                    <div className="star-rating" data-rating="5"></div>
                                </div>
                                <p>Morbi velit eros, sagittis in facilisis non, rhoncus et erat. Nam posuere tristique sem, eu ultricies tortor imperdiet vitae. Curabitur lacinia neque non metus</p>

                                <div className="review-images mfp-gallery-container">
                                    <a href="images/review-image-01.jpg" className="mfp-gallery"><img src="images/review-image-01.jpg" alt="" /></a>
                                </div>
                                <a href="#" className="rate-review"><i className="sl sl-icon-like"></i> Helpful Review <span>12</span></a>
                            </div>
                        </li>

                        <li>
                            <div className="avatar"><img src="http://www.gravatar.com/avatar/00000000000000000000000000000000?d=mm&amp;s=70" alt="" /> </div>
                            <div className="comment-content"><div className="arrow-comment"></div>
                                <div className="comment-by">John Doe<span className="date">May 2019</span>
                                    <div className="star-rating" data-rating="4"></div>
                                </div>
                                <p>Commodo est luctus eget. Proin in nunc laoreet justo volutpat blandit enim. Sem felis, ullamcorper vel aliquam non, varius eget justo. Duis quis nunc tellus sollicitudin mauris.</p>
                                <a href="#" className="rate-review"><i className="sl sl-icon-like"></i> Helpful Review <span>2</span></a>
                            </div>
                        </li>

                        <li>
                            <div className="avatar"><img src="http://www.gravatar.com/avatar/00000000000000000000000000000000?d=mm&amp;s=70" alt="" /></div>
                            <div className="comment-content"><div className="arrow-comment"></div>
                                <div className="comment-by">Kathy Brown<span className="date">June 2019</span>
                                    <div className="star-rating" data-rating="5"></div>
                                </div>
                                <p>Morbi velit eros, sagittis in facilisis non, rhoncus et erat. Nam posuere tristique sem, eu ultricies tortor imperdiet vitae. Curabitur lacinia neque non metus</p>

                                <div className="review-images mfp-gallery-container">
                                    <a href="images/review-image-02.jpg" className="mfp-gallery"><img src="images/review-image-02.jpg" alt="" /></a>
                                    <a href="images/review-image-03.jpg" className="mfp-gallery"><img src="images/review-image-03.jpg" alt="" /></a>
                                </div>
                                <a href="#" className="rate-review"><i className="sl sl-icon-like"></i> Helpful Review <span>4</span></a>
                            </div>
                        </li>

                        <li>
                            <div className="avatar"><img src="http://www.gravatar.com/avatar/00000000000000000000000000000000?d=mm&amp;s=70" alt="" /> </div>
                            <div className="comment-content"><div className="arrow-comment"></div>
                                <div className="comment-by">John Doe<span className="date">May 2019</span>
                                    <div className="star-rating" data-rating="5"></div>
                                </div>
                                <p>Commodo est luctus eget. Proin in nunc laoreet justo volutpat blandit enim. Sem felis, ullamcorper vel aliquam non, varius eget justo. Duis quis nunc tellus sollicitudin mauris.</p>
                                <a href="#" className="rate-review"><i className="sl sl-icon-like"></i> Helpful Review</a>
                            </div>

                        </li>
                    </ul>
                </section>

                <Pagination />
            </div>
        </>
    )
}